import { CountriesEnum, LocalesEnum, RegionsEnum } from 'src/generated/operations';
import { UserSettings } from 'src/types/UserSettings';

export const defaultUserSettings: UserSettings = {
    countryDomain: window.location.origin,
    currentLocale: LocalesEnum.EnGb,
    currentRegion: RegionsEnum.Eu,
    currentCountry: CountriesEnum.Ch,
    shoppingCenter: null,
};

export const ATTRIBUTE_NS = 'attribute';
